<script lang="ts" setup>
import PublishDemand from './publish-demand/index.vue';

const drawerVisible = ref(false);

const publishDemand = () => {
  drawerVisible.value = true;
}
</script>

<template>
  <div class="publish-demand">
    <div class="publish-demand-btn" @click="publishDemand">发布需求</div>

    <PublishDemand v-model="drawerVisible" />
  </div>
</template>

<style scoped lang="scss">
.publish-demand {
  display: inline-block;
  margin-right: 20px;

  .publish-demand-btn {
    height: 36px;
    padding: 8px 12px;
    background: #E8EFFD;
    border-radius: 20px 20px 20px 20px;
    border: 1px solid transparent;
    font-weight: 500;
    font-size: 14px;
    color: #242F57;
    line-height: 20px;
    cursor: pointer;
    box-sizing: border-box;
    
    &:hover {
      border-color: #4050FF;
    }
  }
}
</style>